export default "__VITE_PUBLIC_ASSET__9c7872db__"